












































import ModalBaseOverlay from "./ModalBaseOverlay.vue";
import {Component, Prop, Vue} from 'vue-property-decorator';
import IconCustom from '@/components/lib/IconCustom.vue';
import ButtonCommon from "@/components/lib/ButtonCommon.vue";
import {Status} from '@/entities'

@Component({
  components: {
    IconCustom,
    ModalBaseOverlay,
    ButtonCommon,
  }
})
export default class ModalBase extends Vue {

  @Prop({default: false}) readonly closable?: boolean
  @Prop({default: false}) readonly noPeak?: boolean
  @Prop({default: false}) readonly loading?: boolean
  @Prop({default: false}) readonly error?: boolean
  @Prop({default: false}) readonly info?: boolean
  @Prop({default: false}) readonly cert?: boolean
  @Prop() readonly status?: Status
  @Prop() readonly onClose?: Function
  @Prop() readonly cardClass?: string
  @Prop() readonly contentClass?: string

  get name(): string {
    return this.$storage.getters.getPlatformInfo().name;
  }

  get statusClass(): string {
    let status = this.status;
    return status ? ('status-peak mb-3 ' + status) : '';
  }

  get statusIconName(): string {
    let status = this.status;
    switch (status) {
      case "danger":
        return 'close'
      case "success":
        return 'check'
      case "warning":
        return 'warning'
      default:
        return ''
    }
  }

  private close(): void {
    if (!this.closable) return;
    (this.onClose || this.$storage.actions.closeModal)();
    this.$emit('close');
  }

}
